import { IA_KEY } from 'helpers/ia-logic';
import { watchRatingsActions, handleRouteEnter } from './Ratings.saga';

import Ratings from './RatingsContainer';

export default [
  {
    path: '/ratings/:venueId?/:tab?',
    component: Ratings,
    iaKey: IA_KEY.RATINGS,
    validateParams: ({ venueId, tab }) => {
      // React Router V6+ doesn't support regex validation in the path so in case of a single param, which will always
      // be evaluated as venueId since it's the first one, we need to validate and check if it's actually a venueId or tab.
      if (tab === undefined) {
        const isParamVenueId = /^\d+$/.test(venueId);
        if (isParamVenueId) {
          return { venueId, tab: undefined };
        }
        // If the first param is not a venue ID, it must be a tab
        return { venueId: undefined, tab: venueId };
      }
      return { venueId, tab };
    },
    // double handleRouteEnter is intentional
    pathSagas: [watchRatingsActions, handleRouteEnter],
    locationSagas: [handleRouteEnter],
  },
];
